import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const CopyQrIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 12.365 12.365">
      <g id="qrcode" transform="translate(2.502 2.5)">
        <path
          id="Shape"
          d="M4.613,7a.649.649,0,0,1-.649-.648V4.613a.65.65,0,0,1,.649-.649h1.74A.649.649,0,0,1,7,4.613v1.74A.648.648,0,0,1,6.352,7Zm.067-.716h1.6V4.68H4.68ZM.649,7A.649.649,0,0,1,0,6.352V4.613a.65.65,0,0,1,.649-.649h1.74a.649.649,0,0,1,.648.649v1.74A.648.648,0,0,1,2.389,7Zm.067-.716h1.6V4.68H.716ZM5.124,5.84V5.124H5.84V5.84Zm-.512-2.8a.649.649,0,0,1-.649-.648V.649A.65.65,0,0,1,4.613,0h1.74A.649.649,0,0,1,7,.649v1.74a.648.648,0,0,1-.648.648Zm.067-.716h1.6V.716H4.68ZM.649,3.037A.649.649,0,0,1,0,2.389V.649A.65.65,0,0,1,.649,0h1.74a.649.649,0,0,1,.648.649v1.74a.648.648,0,0,1-.648.648Zm.067-.716h1.6V.716H.716Z"
          transform="translate(-0.001 0)"
          fill={props.color || theme.palette.gray.light}
        />
        <path
          id="Shape-2"
          data-name="Shape"
          d="M9.274,12.365a.5.5,0,0,1,0-.994h2.1v-2.1a.5.5,0,1,1,.994,0v2.1a1,1,0,0,1-.994.994Zm-8.28,0A1,1,0,0,1,0,11.371v-2.1a.5.5,0,1,1,.994,0v2.1h2.1a.5.5,0,0,1,0,.994ZM11.372,3.091V.994h-2.1a.5.5,0,0,1,0-.994h2.1a1,1,0,0,1,.994.994v2.1a.5.5,0,1,1-.994,0ZM0,3.091V.994A1,1,0,0,1,.994,0h2.1a.5.5,0,0,1,0,.994H.994v2.1a.5.5,0,1,1-.994,0Z"
          transform="translate(-2.502 -2.5)"
          fill={props.color || theme.palette.gray.light}
        />
      </g>
    </SvgIcon>
  );
};
